import { createContext, useContext, useState, useEffect } from "react";

const ConnectionContext = createContext(null);

export const useConnection = () => {
  const context = useContext(ConnectionContext);
  if (!context) {
    throw new Error("useConnection must be used within ConnectionProvider");
  }
  return context;
};

export const ConnectionProvider = ({ children }) => {
  const [selectedConnection, setSelectedConnection] = useState(null);
  const [connections, setConnections] = useState([]);

  // Load saved connection from localStorage on mount
  useEffect(() => {
    const savedConnId = localStorage.getItem("selectedConnectionId");
    if (savedConnId && connections.length > 0) {
      const conn = connections.find(c => c.id === savedConnId);
      if (conn) {
        setSelectedConnection(conn);
      }
    }
  }, [connections]);

  // Save selected connection to localStorage
  const selectConnection = (conn) => {
    setSelectedConnection(conn);
    if (conn) {
      localStorage.setItem("selectedConnectionId", conn.id);
    } else {
      localStorage.removeItem("selectedConnectionId");
    }
  };

  // Update connections list
  const updateConnections = (conns) => {
    setConnections(conns);
    // If current selection is no longer valid, clear it
    if (selectedConnection && !conns.find(c => c.id === selectedConnection.id)) {
      selectConnection(null);
    }
    // If no selection and we have connections, try to restore from localStorage
    if (!selectedConnection && conns.length > 0) {
      const savedConnId = localStorage.getItem("selectedConnectionId");
      if (savedConnId) {
        const conn = conns.find(c => c.id === savedConnId);
        if (conn) {
          setSelectedConnection(conn);
        }
      }
    }
  };

  return (
    <ConnectionContext.Provider value={{
      selectedConnection,
      selectConnection,
      connections,
      updateConnections
    }}>
      {children}
    </ConnectionContext.Provider>
  );
};
